import React from 'react';
import Carousel, { CarouselProps } from 'nuka-carousel';
import './FeaturedArtists.scss';
import { CarouselControls } from '../../UI/CarouselControls';
import { get } from '../../../helpers/fp';
import {
    PrismicTitleFieldType,
    PrismicRichTextFieldType,
    PrismicLinkFieldType,
    SliceContext,
    PrismicFluidImageField,
    PrismicImageField,
} from '../types';
import { Next } from './Next';
import { Artist } from './Artist';

export type ArtistItems = {
    featured_artists_title: PrismicTitleFieldType;
    featured_artists_cta_link: PrismicLinkFieldType;
    featured_artists_cta_label: PrismicTitleFieldType;
    featured_artists_description: PrismicRichTextFieldType;
    featured_artists_image: PrismicImageField;
    featured_artists_imageSharp: PrismicFluidImageField;
};

export type FeaturedArtistsProps = {
    slice: {
        fields: ArtistItems[];
    };
    sliceContext: SliceContext;
};

export type FeaturedArtistsState = {
    currentSlideIndex: number;
};

const carouselConfig: CarouselProps = {
    wrapAround: true,
    slidesToShow: 1,
    swiping: true,
    autoplay: false,
    autoplayInterval: 5000,
    dragging: true,
    initialSlideHeight: 100,
    heightMode: 'current',
    speed: 300,
};
class FeaturedArtists extends React.Component<FeaturedArtistsProps, FeaturedArtistsState> {
    state = {
        currentSlideIndex: 0,
    };

    setCurrentSlide = (slideIndex: number) => () => {
        this.setState({ currentSlideIndex: slideIndex });
    };

    render() {
        const artists = this.props.slice.fields;
        const firstSlideHasImage =
            get(['featured_artists_imageSharp', 'childImageSharp', 'fluid'], artists[0]) ||
            get(['featured_artists_image', 'url'], artists[0]);

        return (
            (firstSlideHasImage && (
                <Carousel
                    className="FeaturedArtists"
                    slideIndex={this.state.currentSlideIndex}
                    renderCenterLeftControls={() => <></>}
                    renderCenterRightControls={Next}
                    renderBottomCenterControls={slide => (
                        <CarouselControls onClick={this.setCurrentSlide} slide={slide} theme="light" />
                    )}
                    {...carouselConfig}
                >
                    {artists.map((artist, index) => (
                        <Artist artist={artist} key={index} sliceContext={this.props.sliceContext} />
                    ))}
                </Carousel>
            )) ||
            null
        );
    }
}

export { FeaturedArtists };
